<template>
  <TheTable />
</template>

<script setup>
import TheTable from "@/components/table/TheTable.vue";
</script>
